import { useEffect, useRef, useState } from "react";
import { idDelValor } from "../../../../utils/valorDeUbicacion";
// hooks
import { usePersonaNatural } from "../../../../hooks/usePersonaNatural";
// styled components
import { Button, Select, Form, Input, DatePicker } from "antd";
// dataSelect
import {
  SexoOptions,
  TipoDocumentosOptions,
  EstratoOptions,
  comunasOptions,
} from "../../../../utils/dataSelectOptions";
// style
import moment from "moment";
import "../../Usuario.style.scss";
import { OrientacionSexualoOptions, IdentidadGeneroOptions } from "../../../../utils/dataSelectOptions";
import { ModalDireccion } from "../../../../components/ModalDireccion/ModalDireccion";
import apiLocation from "../../../../api/Participantes/api.location";

import { Convocatoria } from "../../../../models/ConvocatoriasModel/convocatoria.model";
import { Municipio } from "../../../../models/LocationsModels/locations.models";
import { useLocations } from "../../../../hooks/useLocations";
import { openNotification } from "../../../../utils/Notifactions";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { InputNumero } from "../../../../components/Mascaras/InputNumero/InputNumero";
import { useNavigate } from "react-router-dom";
import locale from 'antd/es/date-picker/locale/es_ES';

interface IProps {
  convocatorias?: Convocatoria;
  /**
   * Se avisa al salir de cualquier campo, para que quien monte el formulario
   * pueda guardar lo escrito. Es opcional: sin el, el formulario se comporta
   * como siempre.
   */
  alSalirDeUnCampo?: (participante: any) => void;
  /**
   * La botonera propia del formulario, que lleva a la siguiente pagina del
   * flujo por pasos. El wizard trae la suya.
   */
  mostrarNavegacion?: boolean;
}

export const FormPersonaJuridica = (props: IProps) => {
  // ref input
  const navigate = useNavigate();
  const inputRef = useRef<any>(null);
  const [guardarFormulario, setGuardarFormulario] = useState(false);

  // hook
  const { infoparticipante, setInforParticipante, cargarInformacionParticipante, guardarInformacionParticipante } =
    usePersonaNatural();
  // form fields
  const fields = [
    { name: "numero_documento", value: infoparticipante.numero_documento },
    { name: "tipo_identificacion", value: infoparticipante.tipo_identificacion },
    { name: "primer_nombre", value: infoparticipante.primer_nombre },
    { name: "segundo_nombre", value: infoparticipante.segundo_nombre },
    { name: "primer_apellido", value: infoparticipante.primer_apellido },
    { name: "segundo_apellido", value: infoparticipante.segundo_apellido },
    { name: "fecha_nacimiento", value: infoparticipante.fecha_nacimiento },
    { name: "sexo", value: infoparticipante.sexo },
    { name: "orientacion", value: infoparticipante.orientacion },
    { name: "identidad", value: infoparticipante.identidad },
    { name: "indicativo", value: infoparticipante.indicativo },
    { name: "telefono_celular", value: infoparticipante.telefono_celular },
    { name: "direccion_residencia", value: infoparticipante.direccion_residencia },
    { name: "pais_nacimiento", value: infoparticipante.pais_nacimiento },
    { name: "pais_residencia", value: infoparticipante.pais_residencia },
    { name: "departamento", value: infoparticipante.departamento },
    { name: "municipio", value: infoparticipante.municipio },
    { name: "comuna", value: infoparticipante.comuna },
    { name: "barrio", value: infoparticipante.barrio },
    { name: "estrato", value: infoparticipante.estrato },
    { name: "correo_electronico", value: infoparticipante.correo_electronico },
    { name: "nit", value: infoparticipante.datos_empresa.nit },
    { name: "direccion_empresa", value: infoparticipante.datos_empresa.direccion_empresa },
    { name: "razon_social", value: infoparticipante.datos_empresa.razon_social },
    // Faltaban: su Form.Item existia, pero sin entrada aqui antd nunca
    // recibia el valor guardado y los dos campos salian en blanco.
    { name: "etnia", value: infoparticipante.etnia },
    { name: "comuna_empresa", value: infoparticipante.datos_empresa.comuna_empresa },
  ];

  const { paises, departamentos } = useLocations();

  const [tipoDireccion, setTipoDireccion] = useState('')

  const [municipios, setMunicipios] = useState<Municipio[]>([]);

  /**
   * Carga los municipios del departamento que ya estaba guardado.
   *
   * La lista solo se pedia al elegir un departamento, asi que quien volvia
   * a entrar encontraba el municipio en blanco: tenia su valor, pero
   * ninguna opcion con que mostrarlo.
   */
  useEffect(() => {
    let vigente = true;

    const cargarMunicipiosGuardados = async () => {
      const idDepartamento = infoparticipante.departamento;
      if (!idDepartamento || municipios.length > 0) return;

      try {
        const lista = await apiLocation.obtenerMunicipios(idDepartamento);
        if (vigente) setMunicipios(lista);
      } catch (error) {
        console.error("No se pudieron cargar los municipios guardados", error);
      }
    };

    const cargarBarriosGuardados = async () => {
      // La comuna puede venir con su numero a secas o como "10-La Candelaria",
      // segun que formulario la haya guardado. Mandar el valor compuesto metia
      // un espacio en la URL y el backend respondia 400.
      const idComuna = idDelValor(infoparticipante.comuna);
      if (!idComuna || barrios.length > 0) return;

      try {
        const lista = await apiLocation.obtenerBarrios(idComuna);
        if (vigente) setBarrios(lista);
      } catch (error) {
        console.error("No se pudieron cargar los barrios guardados", error);
      }
    };

    cargarMunicipiosGuardados();
    cargarBarriosGuardados();

    return () => {
      vigente = false;
    };
  }, [infoparticipante.departamento, infoparticipante.comuna]);

  const handleDepartamento = async (id_departamento: number) => {
    try {
      const cob = props.convocatorias?.cobertura == "Área" ? "Área Metropolitana" : props.convocatorias?.cobertura;
      openNotification({
        titulo: "",
        descripcion: "Recuerda que la cobertura de esta convocatoria es de tipo " + cob,
        placement: "bottomRight",
      });
      const municipios = await apiLocation.obtenerMunicipios(id_departamento);
      return setMunicipios(municipios);
    } catch (error) {
      return console.error(error);
    }
  };

  /**
   * La comuna y el barrio solo aplican a Medellin.
   *
   * Antes esto era un estado que solo encendia elegir el municipio, asi que
   * al volver a entrar con MEDELLIN ya guardado los campos ni se dibujaban.
   * Se deduce del municipio: no hay un estado que pueda quedar desfasado.
   *
   * Se compara por contenido porque el valor puede venir como nombre suelto
   * o como "id-nombre", segun lo escriba el guardado o el select.
   */
  const visibleFields = String(infoparticipante.municipio ?? "").includes("MEDELLÍN");
  const handleMunicipio = async (nombreMunicipio: string) => {
    try {
      // La comuna y el barrio se muestran solos: dependen del municipio.
      return;
    } catch (error) {
      return console.log(error);
    }
  };

  const [barrios, setBarrios] = useState([]);
  const handleComunas = async (id_comunas: number) => {
    // Actualizar la comuna en el estado de forma explícita para evitar
    // race condition con onFieldsChange (stale closure).
    setInforParticipante((prev) => ({ ...prev, comuna: String(id_comunas) }));
    try {
      const barrios = await apiLocation.obtenerBarrios(id_comunas);
      setBarrios(barrios)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      cargarInformacionParticipante();
    }
    return () => {
      mounted = false;
    };
  }, []);
  // state
  const [openModal, setOpenModal] = useState(false);

  return (
    <div onBlur={() => props.alSalirDeUnCampo?.(infoparticipante)}>
    <Form
      name="basic"
      size="large"
      layout="vertical"
      fields={fields}
      onFinish={() => {
        guardarInformacionParticipante(guardarFormulario)
      }}
      onFieldsChange={(_, fields: any) => {
        let infoupdate: any = { ...infoparticipante };
        for (const i in fields) {
          infoupdate[fields[i].name] = fields[i].value;
        }
        setInforParticipante(infoupdate);
      }}
    >
      <div className="container-fluid2 mt-4">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item
              label="Razón social"
              name="razon_social"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input
                maxLength={100}
                type="text"
                name="razon_social"
                style={{ width: "100%" }}
                key={`_razon_social`}
                value={infoparticipante.datos_empresa.razon_social}
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "")
                  // setInforParticipante({...infoparticipante, razon_social: e.target.value, datos_empresa.razon_social: e.target.value })
                  setInforParticipante((oldInfo) => {
                    const info = { ...oldInfo }
                    info.datos_empresa.razon_social = e.target.value
                    return info
                  })
                }}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item
              label="NIT"
              name="nit"
              rules={[
                { required: true, message: "Campo obligatorio" },
                { max: 10, message: "Máximo 10 números" },
                { min: 9, message: "Mínimo 9 números" }
              ]}
            >
              <Input
                type="text"
                name="nit"
                key={`_nit`}
                maxLength={10}
                minLength={9}
                style={{ width: "100%" }}
                value={infoparticipante.datos_empresa.nit}
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/ /g, "")
                  setInforParticipante((oldInfo) => {
                    const info = { ...oldInfo }
                    info.datos_empresa.nit = e.target.value
                    return info
                  })
                }}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Dirección empresa"
              name="direccion_empresa"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              {/* <Input style={{ width: "100%" }} /> */}
              <Input
                maxLength={250}
                key={`_direccion_empresa`}
                readOnly
                autoComplete="off"
                style={{ width: "100%" }}
                value={infoparticipante.datos_empresa.direccion_empresa}
                onClick={() => {
                  if (infoparticipante.modalState) {
                    setTipoDireccion("direccion_empresa")
                    setOpenModal(true);

                  }
                }}
              />

            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Tipo de documento"
              name="tipo_identificacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select style={{ width: "100%" }} placeholder="C.C." disabled={true}>
                {TipoDocumentosOptions.map(({ value, text }) => (
                  <Select.Option key={`TIPODOC-${value}`} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Número de documento"
              name="numero_documento"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input style={{ width: "100%" }} placeholder="No." disabled={true} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Primer nombre"
              name="primer_nombre"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <InputTexto maxLength={100} name="primer_nombre" texto={infoparticipante.primer_nombre} setTexto={setInforParticipante} alltexto={infoparticipante} onInput={infoparticipante.primer_nombre} />
              {/* <Input style={{ width: "100%" }} /> */}
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label={
                <>
                  Segundo nombre{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </>
              }
              name="segundo_nombre"
            // rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <InputTexto maxLength={100} name="segundo_nombre" texto={infoparticipante.segundo_nombre} setTexto={setInforParticipante} alltexto={infoparticipante} onInput={infoparticipante.segundo_nombre} />
              {/* <Input style={{ width: "100%" }} /> */}
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Primer apellido"
              name="primer_apellido"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <InputTexto maxLength={100} name="primer_apellido" texto={infoparticipante.primer_apellido} setTexto={setInforParticipante} alltexto={infoparticipante} onInput={infoparticipante.primer_apellido} />
              {/* <Input style={{ width: "100%" }} /> */}
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item
              label={
                <>
                  Segundo apellido{" "}
                  <span className="font-family-Montserrat-Regular font-size-10px font-color-707070"> - Opcional</span>
                </>
              }
              name="segundo_apellido"
            // rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <InputTexto maxLength={100} name="segundo_apellido" texto={infoparticipante.segundo_apellido} setTexto={setInforParticipante} alltexto={infoparticipante} onInput={infoparticipante.segundo_apellido} />
              {/* <Input style={{ width: "100%" }} /> */}
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Fecha de nacimiento"
              name="fecha_nacimiento"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DatePicker locale={locale} placeholder="Fecha nacimiento" style={{ width: "100%" }} format="YYYY-MM-DD"
                onChange={(value) => {
                  if (parseInt(moment(value).format("YYYYMMDD")) > parseInt(moment().format("YYYYMMDD"))) {
                    setInforParticipante({ ...infoparticipante, fecha_nacimiento: '' })
                    return openNotification({
                      titulo: "Error",
                      descripcion: "La fecha seleccionada es mayor a la actual",
                      placement: "bottomRight",
                    });
                  }

                  if (!props.convocatorias?.menor_edad && (moment(value).diff(moment(), 'years')) >= -17) {
                    setInforParticipante({ ...infoparticipante, fecha_nacimiento: '' })
                    return openNotification({
                      titulo: "Error",
                      descripcion: "En esta convocatoria no acepta participantes menores de edad",
                      placement: "bottomRight",
                    });
                  }

                  if (moment(value).diff(moment(), 'years') <= -100) {
                    setInforParticipante({ ...infoparticipante, fecha_nacimiento: '' })
                    return openNotification({
                      titulo: "Error",
                      descripcion: "No puedes escoger fechas mayores a 100 años",
                      placement: "bottomRight",
                    });
                  }

                }} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item label="Género" name="sexo" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                {SexoOptions.map(({ value, text }) => (
                  <Select.Option key={`SEXO-${value}`} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label={
                <>
                  Orientación sexual
                </>
              }
              name="orientacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                {OrientacionSexualoOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label={
                <>
                  Discapacidad
                </>
              }
              name="identidad"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                {IdentidadGeneroOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item label="Etnia" name="etnia" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                <Select.Option value="Palenqueros">Palenqueros</Select.Option>
                <Select.Option value="Comunidades Negras o Afrocolombianas">Comunidades Negras o Afrocolombianas</Select.Option>
                <Select.Option value="Comunidad raizal">Comunidad raizal</Select.Option>
                <Select.Option value="Pueblos y Comunidades Indígenas">Pueblos y Comunidades Indígenas</Select.Option>
                <Select.Option value="Pueblo">Pueblo</Select.Option>
                <Select.Option value="ROM - GITANO">ROM - GITANO</Select.Option>
                <Select.Option value="Ninguno">Ninguno</Select.Option>
              </Select>
            </Form.Item>
          </div>
        </div>
      </div>

      <div className="container-fluid2 mt-5">
        <div className=" font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion2">
          Datos de contacto
        </div>
      </div>
      <div className="container-fluid2 mt-4">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Número de contacto"
              name="telefono_celular"
              rules={[
                { required: true, message: "Campo obligatorio" },
                { max: 10, message: "Máximo 10 números" },
                { min: 10, message: "Mínimo 10 números" }
              ]}
            >
              <InputNumero name="telefono_celular" max={10} texto={infoparticipante.telefono_celular} setTexto={setInforParticipante} alltexto={infoparticipante} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Dirección de residencia"
              name="direccion_residencia"
              rules={[{ required: true, message: "Campo obligatorio" }]}

            >
              <Input
                maxLength={100}
                autoComplete="off"
                style={{ width: "100%" }}
                onClick={() => {
                  if (infoparticipante.modalState) {
                    setTipoDireccion('direccion_residencia')
                    setOpenModal(true);
                  }
                }}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="País de nacimiento"
              name="pais_nacimiento"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select showSearch style={{ width: "100%" }} placeholder="Seleccionar..." ref={inputRef}>
                {paises.map(({ id, nombre }) => (
                  <Select.Option key={id} value={nombre}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="País de residencia"
              name="pais_residencia"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select showSearch style={{ width: "100%" }} placeholder="Seleccionar..." >
                {paises.map(({ id, nombre }) => (
                  <>
                    {nombre == 'COLOMBIA' &&
                      <Select.Option key={id} value={nombre}>
                        {nombre}
                      </Select.Option>
                    }
                  </>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Departamento de residencia"
              name="departamento"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select
                placeholder="Seleccionar..." onChange={handleDepartamento}>
                {departamentos.map(({ id, nombre }) => (
                  <Select.Option key={id} value={id}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item
              label="Ciudad"
              required
              name="municipio"


              rules={[(infoparticipante.departamento !== "" &&
              {
                required: true,
                message: "Campo obligatorio",
              }
              )]}
            >

              <Select
                showSearch
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
                onChange={handleMunicipio} disabled={municipios.length === 0 ? true : false}>
                {municipios?.map(({ id, nombre }) => (
                  <Select.Option key={id} value={nombre}>
                    {nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>


          {visibleFields && (
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
              <Form.Item
                label="Comuna de residencia"
                name="comuna"
                rules={[(infoparticipante.municipio === "MEDELLÍN" &&
                {
                  required: true,
                  message: "Campo obligatorio",
                }
                )]}
              >
                <Select
                  // showSearch
                  // filterOption={(input, option: any) =>
                  //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                  // filterSort={(optionA, optionB) =>
                  //   optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  // }
                  style={{ width: "100%" }} placeholder="Seleccionar..." onChange={handleComunas}>
                  {comunasOptions.map(({ key, value }) => (
                    <Select.Option key={key} value={key}>
                      {key} - {value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}

          {visibleFields && (
            <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
              <Form.Item

                label="Barrio de residencia"
                name="barrio"
                rules={[((infoparticipante.municipio === "MEDELLÍN" && barrios?.length > 0) &&
                {
                  required: true,
                  message: "Campo obligatorio",
                }
                )]}
              >
                <Select
                  // showSearch
                  // filterOption={(input, option: any) =>
                  //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                  // filterSort={(optionA, optionB) =>
                  //   optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  // }
                  style={{ width: "100%" }} placeholder="Seleccionar...">
                  {barrios?.map(({ id, nombre }) => (
                    <Select.Option key={id} value={nombre}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}

          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item
              label="Comuna de la entidad"
              name="comuna_empresa"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Select
                key={`_comuna_empresa`}
                style={{ width: "100%" }}
                placeholder="Seleccionar..."
                value={infoparticipante.datos_empresa.comuna_empresa}
                onChange={(value) => {
                  setInforParticipante((oldInfo) => {
                    const info = { ...oldInfo };
                    info.datos_empresa.comuna_empresa = value;
                    return info;
                  });
                }}
              >
                {comunasOptions.map(({ key, value }) => (
                  <Select.Option key={key} value={key}>
                    {key} - {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item label="Estrato" name="estrato" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                {EstratoOptions.map(({ value, text }) => (
                  <Select.Option key={`ESTRATO-${value}`} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3">
            <Form.Item

              label="Correo electrónico"
              name="correo_electronico"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={100} style={{ width: "100%" }} />
            </Form.Item>
          </div>
        </div>
      </div>
      {(props.mostrarNavegacion ?? true) && (
      <div className="bg-white"
        style={{
          width: "100%",
          justifyContent: "center",
          marginTop: "0.5%",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="justify-content-flex-start align-content-center">
            <Button style={{ marginRight: "1%" }} type="link" className="button-blanco-radius font-size-12px"
              onClick={() => { navigate(-1) }}
            >
              Atrás
            </Button>
          </div>
          <div className="justify-content-flex-end">
            <Button htmlType="submit" className="button-blanco-radius font-size-12px" style={{ marginRight: '10px' }} onClick={() => setGuardarFormulario(true)}>
              Guardar
            </Button>
            <Button htmlType="submit" className="button-azul-radius">
              Continuar
            </Button>
          </div>
        </div>
      </div>
      )}
      <ModalDireccion
        modal={openModal}
        CancelarModal={() => {
          setInforParticipante((oldInfo) => {
            const info = { ...oldInfo }
            console.log("Info dirección: ", info);

            info.datos_empresa.direccion_empresa = info.direccion_empresa
            return info
          })
          setOpenModal(false)
        }}
        AceptarModal={() => {
          setOpenModal(false)
        }}
        directions={infoparticipante}
        setDireccion={setInforParticipante}
        namedirections={tipoDireccion}
        setOpenModal={setOpenModal}
      />
    </Form>
    </div>
  );
};
